module.exports = __webpack_public_path__ + "img/step2.1.fa472241.svg";